class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.localization-selector__button');
    this.panel = this.querySelector('.localization-selector__list');
    this.input = this.querySelector('input[name="locale_code"]');
    this.form = this.querySelector('form');
    this.options = Array.from(this.querySelectorAll('.localization-selector__option'));

    if (!this.button || !this.panel || !this.input || !this.form) return;

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);

    this.button.addEventListener('click', this.onButtonClick);
    this.addEventListener('keydown', this.onKeyDown);
    this.options.forEach((option) => option.addEventListener('click', this.onOptionClick));
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    if (this.onDocumentClick) document.removeEventListener('click', this.onDocumentClick);
  }

  get isOpen() {
    return this.button.getAttribute('aria-expanded') === 'true';
  }

  open() {
    this.panel.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
  }

  close({ restoreFocus = false } = {}) {
    this.panel.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');

    if (restoreFocus) this.button.focus();
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  focusOption(index) {
    const option = this.options[index];
    if (option) option.focus();
  }

  onButtonClick(event) {
    event.stopPropagation();
    this.toggle();
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.close({ restoreFocus: true });
      return;
    }

    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    if (!this.isOpen) this.open();

    const currentIndex = this.options.indexOf(document.activeElement);
    const lastIndex = this.options.length - 1;

    if (event.key === 'Home') {
      this.focusOption(0);
    } else if (event.key === 'End') {
      this.focusOption(lastIndex);
    } else if (event.key === 'ArrowDown') {
      this.focusOption(currentIndex < lastIndex ? currentIndex + 1 : 0);
    } else if (event.key === 'ArrowUp') {
      this.focusOption(currentIndex > 0 ? currentIndex - 1 : lastIndex);
    }
  }

  onOptionClick(event) {
    event.preventDefault();

    const localeCode = event.currentTarget.dataset.value;
    if (!localeCode || localeCode === this.input.value) {
      this.close({ restoreFocus: true });
      return;
    }

    this.input.value = localeCode;
    this.form.submit();
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
